import React, { useCallback } from 'react';
import { useDispatch, batch } from 'react-redux';
import { DateUtils } from '@vectord/utils';

import {
  COURSE_PAUSE_REQUESTED_REQUEST_MODAL_STAGES,
  LearnerInfoPopover,
  setSelectedRequest,
  setCoursePauseRequestedRequestUpdateModalStage,
} from 'features/courseResume';
import { Tappable } from '@vectord/components';
import styles from './CoursePauseRequestedRequestsTableRow.module.scss';
import TableCell from 'components/TableCell';
import TableRow from 'components/TableRow';

function CoursePauseRequestedRequestsTableRow({ coursePauseRequest }) {
  const dispatch = useDispatch();

  const {
    pause_date: pauseDate,
    enable_streak: streakEnabled,
    duration_of_pause: pauseDuration,
    created_at: createdAt,
    to_academy_module: toAcademyModule,
    from_super_batch_academy_topic: fromSbat,
  } = coursePauseRequest;

  const handleUpdate = useCallback(() => {
    batch(() => {
      dispatch(setSelectedRequest(coursePauseRequest));
      dispatch(
        setCoursePauseRequestedRequestUpdateModalStage(
          COURSE_PAUSE_REQUESTED_REQUEST_MODAL_STAGES.update
        )
      );
    });
  }, [dispatch, coursePauseRequest]);

  return (
    <TableRow className={styles.root}>
      <TableCell className={styles.rowCell}>
        <LearnerInfoPopover request={coursePauseRequest} />
      </TableCell>
      <TableCell className={styles.rowCell}>
        {createdAt ? DateUtils.toDDMMYYYY(createdAt) : '-'}
      </TableCell>
      <TableCell className={styles.rowCell}>
        {pauseDate ? DateUtils.toDDMMYYYY(pauseDate) : '-'}
      </TableCell>
      <TableCell className={styles.rowCell}>
        {pauseDuration ? pauseDuration : '-'}
      </TableCell>
      <TableCell className={styles.rowCell}>
        {fromSbat?.['academy_topic']?.['academy_module']?.name || 'N/A'}
      </TableCell>
      <TableCell className={styles.rowCell}>
        {toAcademyModule ? toAcademyModule.name : 'N/A'}
      </TableCell>
      <TableCell className={styles.rowCell}>{`${streakEnabled}`}</TableCell>
      <TableCell className={styles.actionCell}>
        <Tappable
          onClick={handleUpdate}
          className="primary bold btn-small"
          noHighlight
        >
          Update
        </Tappable>
      </TableCell>
    </TableRow>
  );
}

export default CoursePauseRequestedRequestsTableRow;
